import { NhostClient } from '@nhost/nhost-js'

export const nhost = new NhostClient({
  subdomain: 'sihubtivdmbmvkgjgpda',
  region: 'eu-central-1',
  autoRefreshToken: true,
})

export async function refreshSessionIfNeeded(): Promise<boolean> {
  try {
    const session = nhost.auth.getSession()
    if (!session) {
      return false
    }

    const { session: newSession, error } = await nhost.auth.refreshSession()
    if (error || !newSession) {
      console.warn('Token refresh failed:', error?.message)
      return false
    }

    return true
  } catch (err) {
    console.error('Error refreshing session:', err)
    return false
  }
}
